<template>
  <router-view />
</template>

<script>
export default {
  name: 'SuperRgpd',
}
</script>
